import { SortableElement } from "react-sortable-hoc";

import Testimonial from "./Testimonial";

export default SortableElement(Testimonial);
